import React from "react";
import { useLocation, useOutlet } from "react-router-dom";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

export default function AnimatedOutlet() {
  const location = useLocation();
  const outlet = useOutlet();
  const prefersReducedMotion = useReducedMotion();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial={
          prefersReducedMotion
            ? { opacity: 0 }
            : { opacity: 0, y: 8, scale: 0.98, filter: "blur(4px)" }
        }
        animate={
          prefersReducedMotion
            ? { opacity: 1 }
            : { opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }
        }
        exit={
          prefersReducedMotion
            ? { opacity: 0 }
            : { opacity: 0, y: -8, scale: 0.98, filter: "blur(4px)" }
        }
        transition={
          prefersReducedMotion
            ? { duration: 0.12 }
            : { duration: 0.4, ease: [0.25, 1, 0.5, 1] } // smooth-as-f*ck bezier
        }
        className="will-change-transform"
      >
        {outlet}
      </motion.div>
    </AnimatePresence>
  );
}
